/**
 * @generated SignedSource<<b8c601d8488ed75ada590fa954882814>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditArtistManagerInfoMutationInput = {
  artistNodeId: string;
  managerCompany?: string | null;
  managerEmail?: string | null;
  managerLink?: string | null;
  managerName?: string | null;
};
export type ArtistManagerInfoEditMutation$variables = {
  input: EditArtistManagerInfoMutationInput;
};
export type ArtistManagerInfoEditMutation$data = {
  readonly editArtistManagerInfo: {
    readonly artist: {
      readonly managerCompany: string | null;
      readonly managerEmail: string | null;
      readonly managerLink: string | null;
      readonly managerName: string | null;
    } | null;
  } | null;
};
export type ArtistManagerInfoEditMutation = {
  response: ArtistManagerInfoEditMutation$data;
  variables: ArtistManagerInfoEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "data",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managerName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managerLink",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managerCompany",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managerEmail",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ArtistManagerInfoEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditArtistManagerInfoMutation",
        "kind": "LinkedField",
        "name": "editArtistManagerInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ArtistManagerInfoEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "EditArtistManagerInfoMutation",
        "kind": "LinkedField",
        "name": "editArtistManagerInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ea1bf2c50619094b3bd42c88320898fd",
    "id": null,
    "metadata": {},
    "name": "ArtistManagerInfoEditMutation",
    "operationKind": "mutation",
    "text": "mutation ArtistManagerInfoEditMutation(\n  $input: EditArtistManagerInfoMutationInput!\n) {\n  editArtistManagerInfo(data: $input) {\n    artist {\n      managerName\n      managerLink\n      managerCompany\n      managerEmail\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e5d5c0beab416c60697fa92e15f196c";

export default node;
